import './index.scss'
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';

import  ResetAttributes  from '../../../general/ResetButton.js'

import { addFilter } from '@wordpress/hooks';
import apiFetch from '@wordpress/api-fetch';
import { useState, useEffect } from '@wordpress/element';

import { InspectorControls, PanelColorSettings } from '@wordpress/block-editor';
import { 
	PanelBody, 
	SelectControl, 	
	ToggleControl,
	Flex, 
	FlexItem
} from '@wordpress/components';


const allowedBlocks = [ 'core/button', 'core/read-more'];
const abuttonDefaults = {
	aOn: false,
	size: '',
	buttonHover: false,
	bgColor: '',
	color: '',
	iconname: ''
};


const addAttributes = (settings,name) => {
	
	if (!allowedBlocks.includes(name)) return settings;	

	if (typeof settings.attributes !== 'undefined') {
		settings.attributes = {
			...settings.attributes,
			abutton: {
				type: 'object',
				default: abuttonDefaults,
			},
		}
	}
	return settings;
}


const addInspectorControl = (BlockEdit) => (props) => {

		if (!allowedBlocks.includes(props.name)) return <BlockEdit {...props} />;
		
		const { attributes, setAttributes, isSelected } = props;

		const {	abutton = {} } = attributes;

		const orgDefaults = {
			...abuttonDefaults,
			...(attributes.abutton || {}),
		};

		const { 			
			aOn, 
			size, 
			buttonHover, 
			bgColor, 
			color, 
			iconname
		} = orgDefaults;
	

		const isDifferentFromDefault = JSON.stringify({ ...abutton, aOn: undefined }) !== JSON.stringify({ ...abuttonDefaults, aOn: undefined });

		const [ open, setOpen ] = useState();	
		const [ icon, setIcon ] = useState();	

		useEffect( () => {		
			async function fetchIcons() {
			const response = await apiFetch( {
				path: 'aver/v1/iconblock',
				method: 'POST',
				data: { type: 'bootstrap' }							
			} );					
		
			if ( response  ) {		
			//	console.log(response)		
				const allIcons = [{label:'None', value:''}];					
				for ( let i = 0; i < response.length; i++ ) {
					const res = response[ i ];
					allIcons.push({
						label: res,
						value: res
					})				
				}			
				setIcon(allIcons)				
			} 			
		}
		if (open)  fetchIcons();		
		}, [open] );
		

	
		return (
			<>
				<BlockEdit {...props} />

					<InspectorControls group="settings">	
					
						<PanelBody title={__('Extra Settings', 'aver')} initialOpen={ aOn }>		

							<Flex>
								<FlexItem>
									<ToggleControl
										label={__('Enable Extra Settings', 'aver')}
										checked={aOn}
										onChange={(val) => setAttributes({ abutton: {...abutton, aOn: val }})}
									/>
								</FlexItem>
								<FlexItem>
									{ isDifferentFromDefault && (
										<ResetAttributes
											onConfirm={() => {
												setAttributes({
													abutton: abuttonDefaults
												});								
											}}
										/> 
									)}
								</FlexItem>
							</Flex>		
										
							{ aOn  && <>
							
							{ props.name === 'core/button' && <SelectControl
								label={__('Size', 'aver')}
								value={size}
								options={[
									{
										label: __('Default', 'aver'),
										value: '',
									},
									{
										label: __('Small', 'aver'),
										value: 'small',
									},
									{
										label: __('Medium', 'aver'),
										value: 'medium',
									},
									{
										label: __('Large', 'aver'),
										value: 'large',
									},
									{
										label: __('XLarge', 'aver'),
										value: 'xlarge',
									},
								]}							
								onChange={(val) => setAttributes({ abutton: {...abutton, size: val }})}
							/> }	

							{ props.name === 'core/button' && <ToggleControl
								label={ __( 'Hover', 'aver' ) }
								checked={ buttonHover }							
								onChange={(val) => setAttributes({ abutton: {...abutton, buttonHover: val }})}
							/>
							} 	

							<ToggleControl
								label={ __(	'Add Icon', 'aver')}
								checked={ open }								
								onChange={ (newval) => setOpen(newval)}
							/>
							{ open &&  <SelectControl
								label={__('Icon', 'aver')}
								value={iconname}
								options={ icon }							
								onChange={(val) => setAttributes({ abutton: {...abutton, iconname: val }})}
								help={__('Select None to delete the icon','aver')}
							/> } </>}

						</PanelBody>	

						{ buttonHover && aOn && props.name === 'core/button' && <PanelColorSettings 
							title={ __( 'Hover Color Settings', 'aver' ) }
							icon="admin-appearance"
							initialOpen
							disableCustomColors={ false }
							enableAlpha={ true }
							colorSettings={ [
								{
									value: bgColor,
									onChange: ( val ) => setAttributes({ abutton: {...abutton, bgColor: val }}),
									
									label: __( 'Background Color', 'aver' ),
								},
								{
									value: color,
									onChange : ( val ) => setAttributes({ abutton: {...abutton, color: val }}),									
									label: __( 'Text Color', 'aver' ),
								},
							] }
						></PanelColorSettings>
							}	

					</InspectorControls>				

			</>
		);
}




const applyExtraClassEditor = (BlockListBlock) => (props) => {

		if (!allowedBlocks.includes(props.name)) return <BlockListBlock {...props} />	

		const { attributes, wrapperProps, className } = props;
    const {	abutton = {} } = attributes;
		const { aOn, size, buttonHover, bgColor, color, iconname } = abutton;


		if (!aOn) return <BlockListBlock {...props} />;

		const cssstyle = {
			...wrapperProps?.style,		
			...(bgColor && { '--pBgColor': bgColor }),
			...(color && { '--pColor': color }),	
		};
		
		const classes = classnames(
			className, ``,
			{
				[`has-size-${size}`]: size,		
				['has-hover-effect']: buttonHover,									
			}
		);	

		if (props.name === 'core/button' ) {
			// console.log(props.name)
			// Check if the icon is already added to avoid duplication
			if (!attributes.text.includes(`<span class="bi bi-${iconname}"></span>`) && ( `${iconname}` != '' )) {
				// Inject the Bootstrap icon before the button text
				const updatedText = `<span class="bi bi-${iconname}"></span>&nbsp;&nbsp;${attributes.text}`;
				props.attributes.text = updatedText;
			}
		}

		if (props.name === 'core/read-more') {		
			if (!attributes.content.includes(`<span class="bi bi-${iconname}"></span>`) && ( `${iconname}` != '' )) {			
				const updatedText = `${attributes.content}&nbsp;&nbsp;<span class="bi bi-${iconname}"></span>`;
				props.attributes.content = updatedText;
			}
		}

		return (
			<BlockListBlock
				{...props}	
				wrapperProps={ { style : cssstyle  } } 
				className={ classes } 															
			/>
		);
}



addFilter(
	'blocks.registerBlockType',
	'aver/aver-button-attributes',
	addAttributes,
);

addFilter(
	'editor.BlockEdit',
	'aver/aver-button-advanced-control',
	addInspectorControl,
);

addFilter(
	'editor.BlockListBlock',
	'aver/aver-button-editor-class',
	applyExtraClassEditor,
);